export default __webpack_public_path__ + "static/media/flashlight-active.1ff1b103.svg";